import { PUBLIC_BASE } from 'app/config';

const fontBasePath = `${PUBLIC_BASE}/assets/fonts`;
const iconsPath = `${PUBLIC_BASE}/assets/webAppDealerIcons`;

export const fonts = `
  @font-face {
    font-family: 'Objektiv';
    font-display: swap;
    src: url('${fontBasePath}/ObjektivMk3_W_Rg.woff2') format('woff2'),
      url('${fontBasePath}/ObjektivMk3_W_Rg.woff') format('woff');
    font-weight: 200;
    font-style: normal;
    letter-spacing: 0;
  }

  /* 
    We use the same definition with font-weight: normal.
    Otherwise this gets mapped to 400 which we don't support.
    Instead the browser will make a lighter version bigger.
  */
  @font-face {
    font-family: 'Objektiv';
    font-display: swap;
    src: url('${fontBasePath}/ObjektivMk3_W_Rg.woff2') format('woff2'),
      url('${fontBasePath}/ObjektivMk3_W_Rg.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    letter-spacing: 0;
  }

  @font-face {
    font-family: 'Objektiv';
    font-display: swap;
    src: url('${fontBasePath}/ObjektivMk3_W_Md.woff2') format('woff2'),
      url('${fontBasePath}/ObjektivMk3_W_Md.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    letter-spacing: 0;
  }

  @font-face {
    font-family: 'Objektiv';
    font-display: swap;
    src: url('${fontBasePath}/ObjektivMk3_W_Bd.woff2') format('woff2'),
      url('${fontBasePath}/ObjektivMk3_W_Bd.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    letter-spacing: 0;
  }

  /* 
    We use the same definition with font-weight: bold.
    Otherwise this gets mapped to 700 which we don't support.
    Instead the browser will take a lighter font and will just make it bolder.
  */
  @font-face {
    font-family: 'Objektiv';
    font-display: swap;
    src: url('${fontBasePath}/ObjektivMk3_W_Bd.woff2') format('woff2'),
      url('${fontBasePath}/ObjektivMk3_W_Bd.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    letter-spacing: 0;
  }

  @font-face {
    font-family: 'heycar_iconfont';
    src:  url('${iconsPath}/heycar_iconfont.eot?sk163h1');
    src:  url('${iconsPath}/heycar_iconfont.eot?sk163h1#iefix') format('embedded-opentype'),
      url('${iconsPath}/heycar_iconfont.ttf?sk163h1') format('truetype'),
      url('${iconsPath}/heycar_iconfont.woff?sk163h1') format('woff'),
      url('${iconsPath}/heycar_iconfont.svg?sk163h1#heycar_iconfont') format('svg');
    font-weight: normal;
    font-style: normal;
  }
  
`;
